import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8h5dhfnpm: FaireProductEntity = {
  token: "p_g8h5dhfnpm",
  type: "product",
  name: "Wedding Ribbons Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c8cf0c991e4a3e20addbdb31189556e9089d5719bbb44c324656819bdf0a4131.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bcf813401e038a5d6dfeef2a75d814565bb49046a8739ae95f41560bc8f8094.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:59.626Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
